import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-51a8ac5a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "fix-footer" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "footer-layout" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line-bg" }, null, -1))
const _hoisted_5 = { class: "footer-btn" }


const __default__ = { name: 'fixFooterPage' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  autoFooter: {
    type: Boolean,
    default: true
  }
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _createElementVNode("div", _hoisted_3, [
      (__props.autoFooter)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _hoisted_4,
            _createElementVNode("div", _hoisted_5, [
              _renderSlot(_ctx.$slots, "footer")
            ])
          ], 64))
        : _renderSlot(_ctx.$slots, "footer", { key: 1 })
    ])
  ]))
}
}

})